import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationZH from './locales/zh.json';

// 翻译资源
const resources = {
  en: {
    translation: translationEN
  },
  zh: {
    translation: translationZH
  }
};

i18n
  .use(initReactI18next) // 将i18n传递给react-i18next
  .init({
    resources,
    lng: 'zh', // 默认语言
    fallbackLng: 'en', // 当选择的语言不可用时的后备语言
    interpolation: {
      escapeValue: false // 不需要对React进行HTML转义，React已经做了
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n; 